import React, { useEffect, useState, useMemo } from "react";
import { CardBody, Card } from "reactstrap";
import { Input, FormGroup, Label, Form } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { ProfileService } from "../../../../../services/ProfileService";
import "../../../../../assets/css/overridestyles.css";
import { useHistory } from "react-router-dom";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";

const CareerHighlights = () => {
  const history = useHistory();
  const [inputField, setInputField] = useState({
    tagline: "",
    highlights1: "",
    highlights2: "",
  });
  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);

  const submitButton = () => {
    const highlights = [];

    if (inputField.highlights1 !== "") {
      highlights.push(inputField.highlights1);
    }

    if (inputField.highlights2 !== "") {
      highlights.push(inputField.highlights2);
    }

    const highlightsReqReqest = {
      tagline: inputField.tagline,
      highlights: highlights,
    };

    setSaveBtnEnabled(true);
    ProfileService.addHighlights(highlightsReqReqest).then((response) => {
      setSaveBtnEnabled(false);
      try {
        // toast.success("Career highlights saved successfully");
      } catch (err) {
        console.error("addHighlights" + JSON.stringify(err));
      }
    });
    history.push("/smartresume");
  };
  const handleCancelButton=()=>{
    history.push("/smartresume");
  }

  const getHighlights = () => {
    ProfileService.getCareerHighlights().then((response) => {
      try {
        var careerDetails = response.data;
        if (careerDetails != null) {
          if (careerDetails.tagline !== null || careerDetails.tagline != "") {
            setInputField((prevState) => ({
              ...prevState,
              tagline: careerDetails.tagline,
            }));
          }

          if (careerDetails.highlights != null) {
            if (careerDetails.highlights[0] !== null) {
              setInputField((prevState) => ({
                ...prevState,
                highlights1: careerDetails.highlights[0],
              }));
            }

            if (careerDetails.highlights[1] !== null) {
              setInputField((prevState) => ({
                ...prevState,
                highlights2: careerDetails.highlights[1],
              }));
            }
          }
        }
      } catch (err) {
        console.error("getCareerHighlights" + JSON.stringify(err));
      }
    });
  };

  let count = 0;
  useEffect(() => {
    getHighlights();
  }, [count]);

  return (
    <div className="myProfileColumn 
    min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
    min-lg:order-1 max-lg:order-2 t-profile-mb
">
<div className="myProfile-container relative  min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg t-profile-padding ">
        <div className="col-sm-12">
          <div className="barmenu_content">
            <div className="addexperience right">
              <div className="profile-card-title">
                  <h2 className="t-h2-font-sm">
                    <strong>Career Highlights</strong>
                  </h2>
              </div>              
              <label>
              Catch the attention of employers who skim resumes.
              </label><br/>
              <label>Write three statements to showcase your accomplishments.</label>
              <div className="horizontal_line"></div>
            </div>
            <div className="mt-4">
                <Form>
                  <FormGroup>
                    <Label className="profile-card-subtitle">
                      Please set a tagline: (80 chars max)
                    </Label>
                    <Input
                    className="t-rounded-lg "
                      type="text"
                      name="tagline"
                      maxLength="80"
                      data-testid="careerhighlights-tagline"
                      placeholder="e.g. Full Stack Developer"
                      onChange={inputsHandler}
                      value={inputField.tagline}
                    />
                  </FormGroup>

                  <FormGroup className="mt-4">
                    <Label className="profile-card-subtitle">
                      Please provide two highlights for employers: (2 lines of
                      72 chars)
                    </Label>
                    <Input
                      rows="4"
                      className="t-rounded-lg "
                      data-testid="careerhighlights-highlights1"
                      type="textarea"
                      name="highlights1"
                      maxLength="72"
                      placeholder="e.g. Experienced call center shift leader"
                      onChange={inputsHandler}
                      value={inputField.highlights1}
                    />

                    <Input
                      rows="4"
                      
                      data-testid="careerhighlights-highlights2"
                      type="textarea"
                      name="highlights2"
                      maxLength="72"
                      placeholder="e.g. AWS certified and experience"
                      className="mt-5 t-rounded-lg "
                      onChange={inputsHandler}
                      value={inputField.highlights2}
                    />
                  </FormGroup>
                </Form>

                <div>
                <TeamanicsButton
                className="mt-3"
                onClick={handleCancelButton}
                  >
                    Cancel
                  </TeamanicsButton>
                  <TeamanicsButton
                  className="ml-2"
                    disabled={saveBtnEnabled}
                  onClick={submitButton}
                  >
                    Save
                  </TeamanicsButton>
                 
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CareerHighlights;
